import React from "react"
import { Link, useParams } from "react-router-dom"
import { useSelector } from "react-redux"

import { selectPreflightSummary, selectRunDetail } from "../clientBatchingSlice"

// Badge colour tracks the worst thing found, so a run that cannot produce a file reads red.
const SEVERITY_BADGE = {
    will_fail: "#cf1322",
    will_be_wrong: "#d46b08",
    will_be_blank: "#d4b106",
    not_checked: "#8c8c8c",
}

// Sub-header for the Client Batching pages, passed to ConsoleLayout as `header`. Ordered by the
// workflow: sweep, look at what you swept, see what is broken about it, then finalize. Review and
// Pre-Flight appear only once a run is in scope, since neither means anything without one.
export default function ClientBatchingNav({ activeTab }) {
    const { runId } = useParams()

    const summary = useSelector(selectPreflightSummary)
    const run = useSelector(selectRunDetail)
    // Only once the header for THIS run has loaded, so another run's count never shows here.
    const flaggedCount = run && Number(run.id) === Number(runId) ? run.flagged_count || 0 : 0

    const tabs = [{ route: "", tab: "picker", title: "Select Clients" }]
    // Only while a run is in scope: there is nothing to review without one.
    if (runId) {
        tabs.push({ route: `/runs/${runId}`, tab: "review", title: "Review Bills" })
        // Red-flagged bills held out of the run (A/R feedback item 1). Hidden when there are none,
        // except while you are on it -- clearing the last flag should not yank the tab away.
        if (flaggedCount > 0 || activeTab === "flagged") {
            tabs.push({
                route: `/runs/${runId}/flagged`,
                tab: "flagged",
                title: "Flagged",
                count: flaggedCount,
                countSeverity: "will_fail",
            })
        }
        tabs.push({
            route: `/runs/${runId}/preflight`,
            tab: "preflight",
            title: "Pre-Flight",
            // Rendered only once loaded, so the number never appears and then changes.
            count: summary ? summary.total : null,
            countSeverity: summary ? summary.worst_severity : null,
        })
        tabs.push({ route: `/runs/${runId}/finalize`, tab: "finalize", title: "Finalize" })
    }
    tabs.push({ route: "/today", tab: "today", title: "Today's Runs" })

    return (
        <div>
            <h2>
                <Link to={() => `/client_batching`}>Client Batching</Link>
            </h2>

            <ul className="header-tab-nav" role="navigation">
                {tabs.map((t, i) => (
                    <li key={i}>
                        <Link to={() => `/client_batching${t.route}`}>
                            <button type="link" className={`${activeTab === t.tab ? "selected" : ""}`}>
                                {t.title}
                                {t.count > 0 && (
                                    <span
                                        className="badge"
                                        style={{
                                            marginLeft: "8px",
                                            background: SEVERITY_BADGE[t.countSeverity] || "#8c8c8c",
                                            color: "#fff",
                                        }}
                                    >
                                        {t.count}
                                    </span>
                                )}
                            </button>
                        </Link>
                    </li>
                ))}
            </ul>
        </div>
    )
}
